import gql from 'graphql-tag'

// TODO : Adjust this query soon !!!
export const GET_MEDIA_LIST = gql`
  query DownloadVideoHistories($filter: DownloadVideoHistoriesFilter) {
    downloadVideoHistories(filter: $filter) {
      message
      isSuccessful
      status
      downloadVideoHistories {
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        data {
          channel
          convertedChannel
          downloadId
          downloadOn
          endTime
          mediaFilename
          startTime
          status
          url
          identifier
          rawAlerts {
            rawAlertId
            alertCode
            createdOn
            alert {
              alertCode
              descriptionEng
              descriptionIdn
            }
            isImportant
            latitude
            longitude
          }
          users {
            fullname
          }
          vehicle {
            hullNo
            id
            licensePlate
            parentVehicle {
              licensePlate
              driver1 {
                fullname
              }
            }
            device {
              timezone
              deviceCode
            }
            driver1 {
              fullname
            }
            vehicleType {
              category
              type
              manufacturer
            }
            vehicle2Vgroup {
              vgroup {
                name
              }
              vgroupId
            }
          }
        }
      }
    }
  }
`
